/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/AgenticServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/AgenticPromptMgmtConstants';
import utils from '../../../../common/utils';
import { getPromptV2Client } from '../../../studio/services/prompt/promptServiceHelpers';

export default class GetAgenticPromptHistoryService extends BaseService {
  constructor() {
    super(constants.GET_AGENTIC_PROMPT_HISTORY, 'GetAgenticPromptHistoryServiceStatus');
    this.responsePromptRefs = new WeakMap();
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { promptRef } = payload;
    const { client, headers: reqHeaders } = await getPromptV2Client(this, headers);
    const response = await client.get(`/prompts/${encodeURIComponent(promptRef)}/history`, {
      headers: reqHeaders
    });
    this.responsePromptRefs.set(response, promptRef);
    return response;
  }

  handleResponse(response) {
    const promptRef = this.responsePromptRefs.get(response) ?? null;
    Framework.getStoreRegistry().getStore('agenticPromptModel').handleHistoryResponse(response.data, { promptRef });
  }

  handleError(error) {
    Framework.getStoreRegistry()
      .getStore('agenticPromptModel')
      .handleServiceError(error, PROMPT_MANAGEMENT_LANG_KEYS.ERROR_HISTORY, constants.GET_AGENTIC_PROMPT_HISTORY_ERROR);
  }
}
